// ResetPassword.js
import React, { useState } from 'react';
import { supabase } from '../../shared/infra/auth/SupabaseClient';
import './style/login.scss';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage('');

    // Check if both passwords match
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    // Update the user's password via Supabase
    const { data, error } = await supabase.auth.updateUser({ password: newPassword });

    if (error) {
      setError(error.message);
      console.log('error: ', error);
    } else {
      setMessage("Password updated successfully.");
      sleep(1500).then(() => {
        window.location.href = '/home';
      });
    }
  };

  return (
      <div className="login-container">
        <h2>Reset Password</h2>
        <form onSubmit={handlePasswordReset}>
          <div className="form-group">
            <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
            />
          </div>
          <div className="form-group">
            <input
                type="password"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
            />
          </div>
          <div className="button-group">
            <button type="submit" className="login-button">
              Update Password
            </button>
          </div>
        </form>
        {error && <p className="error-message">{error}</p>}
        {message && <p className="success-message">{message}</p>}
      </div>
  );
};

export default ResetPassword;
